module.exports = {
          srcSet: __webpack_public_path__ + "fc10be8df0b8b98aae555d487206dab2-2500.png"+" 2500w",
          images:[ {path: __webpack_public_path__ + "fc10be8df0b8b98aae555d487206dab2-2500.png",width: 2500,height: 649}],
          src: __webpack_public_path__ + "fc10be8df0b8b98aae555d487206dab2-2500.png",
          toString:function(){return __webpack_public_path__ + "fc10be8df0b8b98aae555d487206dab2-2500.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAADCAYAAACqPZ51AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAYUlEQVR4nC3MsQ3CUBAE0fPHkWmBJuiEDlyXiyN1gIjAEgL/m0EnOdhk9TQBhNrUcUvbfTde6XXtzMr0TiJhLHQCCsajMzw78YHblizC5duzYIujWBuU2Kk6k3KuD2w/jD/r31qQrsPd7gAAAABJRU5ErkJggg==",
          width: 2500,
          height: 649
        }